import PropTypes from 'prop-types';
import React from 'react';
import Modal from '../Modal';

const PaymentItemDetailsModal = ({ paymentItem, onClose }) => {
    if (!paymentItem) return null;

    const formatValue = (val) => (val === null || val === undefined || val === '') ? '-' : val;

    const details = [
        { label: 'ID', value: paymentItem.id },
        { label: 'Order ID', value: paymentItem.orderId },
        { label: 'Quotation ID', value: paymentItem.quotationId },
        { label: 'Invoice Type', value: paymentItem.invoiceType },
        { label: 'Status', value: paymentItem.status },
        { label: 'Subtotal', value: paymentItem.subTotal },
        { label: 'Discount', value: paymentItem.discount },
        { label: 'Discount %', value: paymentItem.discountPercentage },
        { label: 'GST %', value: paymentItem.gstPercentage },
        { label: 'GST', value: paymentItem.gst },
        { label: 'CGST', value: paymentItem.cgst },
        { label: 'IGST', value: paymentItem.igst },
        { label: 'SGST', value: paymentItem.sgst },
        { label: 'Cess Amount', value: paymentItem.cessAmount },
        { label: 'Cess %', value: paymentItem.cessPercentage },
        { label: 'Total Amount', value: paymentItem.totalAmount },
        { label: 'Notes', value: paymentItem.notes },
        { label: 'Ref Entity Type', value: paymentItem.refEntityType },
        { label: 'Ref Entity Value', value: paymentItem.refEntityValue },
    ];

    return (
        <Modal title={`Payment Item #${paymentItem.id} Details`} onClose={onClose}>
            <div className="space-y-3">
                <div className="grid gap-2">
                    {details.map(({ label, value }) => (
                        <div key={label} className="flex justify-between items-start py-2 border-b border-gray-100 last:border-0">
                            <span className="text-sm font-medium text-gray-600 min-w-[140px]">{label}</span>
                            <span className="text-sm text-gray-900 text-right break-all">
                                {typeof value === 'object' && value !== null ? JSON.stringify(value) : formatValue(value)}
                            </span>
                        </div>
                    ))}
                </div>
                {paymentItem.additionalDetails && Object.keys(paymentItem.additionalDetails).length > 0 && (
                    <div className="pt-2 mt-2 border-t border-gray-200">
                        <div className="text-sm font-medium text-gray-600 mb-2">Additional Details</div>
                        <pre className="text-xs bg-gray-50 p-3 rounded overflow-x-auto">
                            {JSON.stringify(paymentItem.additionalDetails, null, 2)}
                        </pre>
                    </div>
                )}
            </div>
        </Modal>
    );
};

PaymentItemDetailsModal.propTypes = {
    paymentItem: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

export default PaymentItemDetailsModal;
